import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme: any) => ({
  requestContent: { padding: theme.spacing(0.5, 2.5, 0), marginLeft: theme.spacing(6), [theme.breakpoints.down('xs')]: { marginLeft: 0 } },
  titleRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: theme.spacing(2), marginBottom: theme.spacing(1.5), [theme.breakpoints.down('xs')]: { alignItems: 'flex-start', flexDirection: 'column' } },
  actions: { padding: theme.spacing(0.5, 2.5, 1.5), gap: theme.spacing(1), justifyContent: 'flex-end' },
  pendingChip: { color: '#8a5a00', background: '#fff4d6' },
  rejectButton: { color: '#9b2737', borderColor: '#e4aab3' },
}));
